const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/tarifs", {
	title: __("Tarifs", "wp-apidae"), // Block title.
	description: __("Affiche les tarifs et moyens de paiement.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.price
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		tarifs_en_clair: {
			type: "boolean",
			default: true,
		},
		tarif_comprend: {
			type: "boolean",
			default: true,
		},
		tarif_comprend_pas: {
			type: "boolean",
			default: true,
		},
		modes_paiements: {
			type: "boolean",
			default: true,
		},
		indication_tarif: {
			type: "boolean",
			default: false,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Indication tarif' ) }
								checked={ attributes.indication_tarif }
								onChange={ () => {
									props.setAttributes({ indication_tarif: ! attributes.indication_tarif });
								} }
							/>
						<ToggleControl
								label={ __( 'Tarifs en clair' ) }
								checked={ attributes.tarifs_en_clair }
								onChange={ () => {
									props.setAttributes({ tarifs_en_clair: ! attributes.tarifs_en_clair });
								} }
							/>
							<ToggleControl
								label={ __( 'Inclus dans le tarif' ) }
								checked={ attributes.tarif_comprend }
								onChange={ () => {
									props.setAttributes({ tarif_comprend: ! attributes.tarif_comprend });
								} }
							/>
							<ToggleControl
								label={ __( 'Non inclus dans le tarif' ) }
								checked={ attributes.tarif_comprend_pas }
								onChange={ () => {
									props.setAttributes({ tarif_comprend_pas: ! attributes.tarif_comprend_pas });
								} }
							/>
							<ToggleControl
								label={ __( 'Modes de paiements' ) }
								checked={ attributes.modes_paiements }
								onChange={ () => {
									props.setAttributes({ modes_paiements: ! attributes.modes_paiements });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/tarifs"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
